var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b, _c;
import * as React from 'react';
import { DVSClientClass, getDefaultEdgeUrl } from '@doordash/lib-dvs-client';
import { DVSClientProvider } from '@doordash/lib-dvs-client/lib/react';
import { getTelemetryInstance } from '../../utils/useTelemetry';
import { useGetConsumerAndTeamInfo } from './useGetConsumerAndTeamInfo';
import { isLocalEnvironment } from '@doordash/lib-environment';
export var DV2_NAMES = {
    ddfwHideTalktoSalesModule: 'ddfwHideTalktoSalesModule',
    ddfwAllowCreateBudgetPlaceOrder: 'ddfwAllowCreateBudgetPlaceOrder',
    ddfwWorkOnboardEmStepper: 'ddfwWorkOnboardEmStepper',
    ddfwOnboardingBudgetNotification: 'ddfwOnboardingBudgetNotification',
    ddfwRecurringGroupOrder: 'ddfwRecurringGroupOrder',
    ddfwWorkPortalGroupOrdersCarouselId: 'ddfwWorkPortalGroupOrdersCarouselId',
    ddfwVouchers: 'ddfwVouchers',
    ddfwVouchersKillSwitch: 'ddfwVouchersKillSwitch',
    ddfwRecurringGoSplitBillCarts: 'ddfwRecurringGoSplitBillCarts',
    ddfwBudgetReminderAutomation: 'should-enable-budget-notification-automation',
    ddfwRgoShowWeekends: 'ddfwRgoShowWeekends',
    ddfbEmWithPersonalAccount: 'ddfbEmWithPersonalAccount',
    ddfbNewUserFunnelExperience: 'ddfbNewUserFunnelExperience',
    ddfwVouchersV2: 'ddfwVouchersV2',
    ddfwVoucherV2PublicPage: 'ddfwVoucherV2PublicPage',
    ddfwHideVouchersForDPOnly: 'ddfwHideVouchersForDPOnly',
    ddfbExpandedEMCategories: 'ddfbExpandedEMCategories',
    ddfbHasActiveBenefitOnlyJoinEmail: 'tms-new-join-invite-email-10312023',
    ddfbContactSalesNewFields: 'ddfbContactSalesNewFields',
};
export var dv2Defaults = (_a = {},
    _a[DV2_NAMES.ddfwHideTalktoSalesModule] = false,
    _a[DV2_NAMES.ddfwWorkOnboardEmStepper] = false,
    _a[DV2_NAMES.ddfwOnboardingBudgetNotification] = false,
    _a[DV2_NAMES.ddfwRecurringGroupOrder] = false,
    _a[DV2_NAMES.ddfwVouchers] = false,
    _a[DV2_NAMES.ddfwVouchersKillSwitch] = false,
    _a[DV2_NAMES.ddfwRecurringGoSplitBillCarts] = false,
    _a[DV2_NAMES.ddfwBudgetReminderAutomation] = false,
    _a[DV2_NAMES.ddfwRgoShowWeekends] = false,
    _a[DV2_NAMES.ddfbEmWithPersonalAccount] = false,
    _a[DV2_NAMES.ddfbNewUserFunnelExperience] = false,
    _a[DV2_NAMES.ddfwVouchersV2] = false,
    _a[DV2_NAMES.ddfwVoucherV2PublicPage] = false,
    _a[DV2_NAMES.ddfwHideVouchersForDPOnly] = false,
    _a[DV2_NAMES.ddfbExpandedEMCategories] = false,
    _a[DV2_NAMES.ddfbHasActiveBenefitOnlyJoinEmail] = false,
    _a[DV2_NAMES.ddfbContactSalesNewFields] = false,
    _a);
// Created as a separate object so we do not have to cast all existing experiments to boolean
export var dv2DefaultsNonBoolean = (_b = {},
    // Place Order experiment
    // 0 - no "Place an Order" button
    // 1 - "Place an Order" at the top of the menu items (aka Kaiser experiment)
    // 2 - "Place an Order" at the bottom of the menu items
    _b[DV2_NAMES.ddfwAllowCreateBudgetPlaceOrder] = 0,
    _b);
export var dv2DefaultsString = (_c = {},
    _c[DV2_NAMES.ddfwWorkPortalGroupOrdersCarouselId] = 'c6f7a7be-0134-440d-a200-801094ac6379',
    _c);
export var DVSClient = new DVSClientClass(process.env.NODE_ENV === 'QA'
    ? {
        // Point to DV2 development environment when in QA
        dvsEdgeUrl: getDefaultEdgeUrl('development'),
    }
    : {});
export var PortalDVSClientProvider = function (_a) {
    var children = _a.children;
    var context = useGetConsumerAndTeamInfo();
    DVSClient.init({
        application: 'app-corp-consumer-portal',
        appVersion: isLocalEnvironment() ? 'development' : process.env.APP_VERSION,
        exposuresEnabled: false,
        os: 'web',
        namespaces: ['app-corp-consumer-portal'],
        telemetry: getTelemetryInstance(),
    });
    React.useEffect(function () {
        DVSClient.evaluate(__assign({}, context));
    }, [context]);
    return React.createElement(DVSClientProvider, { client: DVSClient }, children);
};
export default PortalDVSClientProvider;
